import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  HostBinding,
  Inject,
} from '@angular/core';

import { DrawerContainerComponent } from './drawer-container.component';

@Component({
    selector: 'lui-drawer-content',
    template: '<ng-content></ng-content>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DrawerContentComponent {
  @HostBinding('class') hostClass = 'lui-drawer-content';

  @HostBinding('style.margin-left.px') get marginLeft() {
    return this._container._contentMargins.left;
  }

  @HostBinding('style.margin-right.px') get marginRight() {
    return this._container._contentMargins.right;
  }

  constructor(
    @Inject(forwardRef(() => DrawerContainerComponent))
    public _container: DrawerContainerComponent
  ) {}
}
